/**
 * Angular 2 decorators and services
 */

import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { environment } from 'environments/environment';
import { AppState } from './app.service';

/**
 * App Component
 * Top Level Component
 */

@Component({
  selector: 'app',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./app.component.scss'],
  templateUrl: './app.component.pug',
})
export class AppComponent implements OnInit {
  public param = {value: 'world'};
  public name = 'Angular Starter';
  public tipe = 'assets/img/tipe.png';
  public twitter = 'https://twitter.com/gdi2290';
  public url = 'https://tipe.io';
  public showDevModule: boolean = environment.showDevModule;

  public elements = [
    // {
    //   name: 'Home',
    //   URL: ['/']
    // },
    {
      name: 'System Requirements',
      URL: ['./sysreq']
    },
    {
      name: 'Changelog',
      URL: ['./changelog']
    },
    {
      name: 'Features',
      URL: ['./features']
    },
    {
      name: 'Get Zinc',
      URL: ['./get-zinc']
    },
    // {
    // name: 'Admin',
    // URL: ['./admin']
    // },
    {
      name: 'Maps',
      URL: ['./maps']
    }
  ];

  constructor( public translate: TranslateService, public appState: AppState) {
    translate.setDefaultLang('en');
    const prevLang = localStorage.getItem('lang');
    if (prevLang === 'en' || prevLang === 'ru') {
      translate.use(prevLang);
    } else {
      translate.use('en');
    }
  }
  public translatePage(lang) {
    this.translate.use(lang);
    localStorage.setItem('lang', lang);
  }

  public ngOnInit() {
    console.log('Initial App State', this.appState.state);

  }
}

/**
 * Please review the https://github.com/AngularClass/angular2-examples/ repo for
 * more angular app examples that you may copy/paste
 * (The examples may not be updated as quickly. Please open an issue on github for us to update it)
 * For help or questions please contact us at @AngularClass on twitter
 * or our chat on Slack at https://AngularClass.com/slack-join
 */



// WEBPACK FOOTER //
// ./src/app/app.component.ts